import { CategoryState, CategoryTypes, CategoryActionTypes } from './types'
import { Reducer } from 'redux'

const initialState: CategoryState = {
  categoryList: { items: [] }
}

type ReducerOpts = Reducer<CategoryState, CategoryActionTypes>
const reducer: ReducerOpts = (state = initialState, action: CategoryActionTypes): CategoryState => {
  let index = -1
  switch (action.type) {
    case CategoryTypes.CATEGORY_CREATE:
      return {
        ...state,
        categoryList: { ...state.categoryList, items: [action.payload, ...state.categoryList.items] }
      }
    case CategoryTypes.CATEGORY_UPDATE:
      index = state.categoryList.items.findIndex(item => item.id === action.payload.id)
      return {
        ...state,
        categoryList: {
          ...state.categoryList,
          items: [
            ...state.categoryList.items.slice(0, index),
            action.payload,
            ...state.categoryList.items.slice(index + 1)
          ]
        }
      }
    case CategoryTypes.CATEGORY_DELETE:
      index = state.categoryList.items.findIndex(item => item.id === action.payload)
      return {
        ...state,
        categoryList: {
          ...state.categoryList,
          items: [
            ...state.categoryList.items.slice(0, index),
            ...state.categoryList.items.slice(index + 1)
          ]
        }
      }
    case CategoryTypes.CATEGORY_GET:
      return { ...state, category: action.payload }
    case CategoryTypes.CATEGORY_LIST:
      return { ...state, categoryList: { items: action.payload, pagination: action.pagination } }
    default:
      return state
  }
}

export default reducer
